/** @format */

export {
    Department,
    type Taxonomy,
    type TaxonomyTerm,
    type TaxonomyTermPage,
    TaxonomyTermType,
} from './config/types';
